import React from "react";
import GridContainer from "@frameworks/web/components/generic/CommonUI/GridContainer";
import ClientDetails from "./ClientDetails";
var ClientHeader = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement(GridContainer, { parentClass: "m-0 mw-none" },
            React.createElement(ClientDetails, null))));
};
export default ClientHeader;
